import { Desktop } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'
import type { SidebarManifest } from 'modules/core/lib/manifests/types'

export const sidebarManifest: SidebarManifest = (navigation) => {
  return [
    {
      identifier: 'equipment',
      name: i18n.t('it_management.it_inventory.title'),
      factorialOneIcon: Desktop,
      path: navigation.it_management.fullPath(),
      group: 'company',
      module: 'it_management',
      priority: 'lowest',
    },
  ]
}
